import { useQuery, useQueryClient } from '@tanstack/react-query';

/**
 * Shared promotions query key
 * This allows different components to access the same promotions data
 */
export const PROMOTIONS_QUERY_KEY = ['shared-promotions'];

/**
 * Hook to access shared promotions data
 * This replaces the Redux generalConfiguration.promotions
 *
 * The promotions are fetched by FeaturedSlider/HorizontalPromoSlider
 * and can be accessed by other components like PPVModal
 */
export const useSharedPromotions = () => {
    const queryClient = useQueryClient();

    // Try to get promotions from cache immediately
    const cachedPromotions = queryClient.getQueryData(PROMOTIONS_QUERY_KEY);

    return useQuery({
        queryKey: PROMOTIONS_QUERY_KEY,
        queryFn: async () => {
            // This query doesn't fetch - it just reads from cache
            // The actual fetching is done by usePromotionUtils in FeaturedSlider
            // Return cached data if available, otherwise empty array
            return cachedPromotions || [];
        },
        staleTime: Infinity, // Never goes stale
        gcTime: Infinity, // Keep in memory forever
        initialData: cachedPromotions || [], // Use cached data as initial data
    });
};

// /**
//  * Function to save promotions to shared React Query cache
//  * Call this from components that fetch promotions (like FeaturedSlider)
//  */
// export const savePromotionsToCache = (queryClient: any, promotions: any[]) => {
//     queryClient.setQueryData(PROMOTIONS_QUERY_KEY, promotions);
// };

// /**
//  * Function to get promotions from shared React Query cache
//  * Use this in components that need promotions but don't fetch them
//  */
// export const getPromotionsFromCache = (queryClient: any): any[] => {
//     const promotions = queryClient.getQueryData(PROMOTIONS_QUERY_KEY);
//     return promotions || [];
// };
